<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="locationId">
                <wbo-location-multi-select-search-control></wbo-location-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'outletId'">
                <wbo-outlet-multi-select-search-control></wbo-outlet-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'terminalFunction'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'type'">
                <wbo-single-select-search-control>
                    <wbo-terminal-type-select-options></wbo-terminal-type-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-column field="location"></wbo-column>
        <wbo-column field="outlet"></wbo-column>
        <wbo-column field="terminalFunction"></wbo-column>
        <wbo-column field="type"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
